function CurFt(prop) {
    // console.log(prop)
    if (prop.currency !== '') {
        let USDollar = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: prop.currency,
        });
        return USDollar.format(prop.price);
    } else {
        const fixedNumber = Number.parseFloat(prop.price).toFixed(2);
        return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}

export default CurFt
